export default "__VITE_ASSET___LpJXb1M__"